<span class="fas fa-circle"
      [ngClass]="ratingClass"></span>
@if (showText) {
    <label class="ms-1">{{ ratingText }}</label>
}
